import React from 'react'
import styled, { css } from 'styled-components'

const Button = styled.button`
  cursor: ${props => !props.disabled && 'pointer'};
  display: flex;
  background: ${props =>
    props.background
      ? props.background.charAt(0) === '#'
        ? props.background
        : props.theme.global.colors[props.background]
      : 'none'};
  border: none;
  color: ${props => props.theme.global.colors[props.color || 'text']};
  text-decoration: ${props => (props.underline ? 'underline' : 'none')};
  text-underline-offset: ${props => (props.underline ? '2px' : 'none')};
  font-weight: ${props => (props.weight ? props.weight : 400)};
  font-size: ${props => (props.fontSize ? props.fontSize : 'inherit')};
  ${props =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${props =>
    props.disabled &&
    css`
      opacity: 0.3;
    `}
  &:hover {
    text-decoration: underline;
    ${props => props.hoverStyles};
  }
  &:focus-visible {
    outline: none;
    background-color: ${props => props.theme.global.colors.hoverBg};
  }
`

const TextButton = props => {
  return (
    <Button
      {...props}
      disabled={props.loading || props.disabled}
      underline={props.underline || false}
      hoverStyles={props.hoverStyles}
    >
      {props.label}
    </Button>
  )
}

export default TextButton
